export default {"src":"/_next/static/media/PRVA.0495841b.svg","height":18,"width":18};